const isExternal = url => {
  const r = new RegExp('^(?:[a-z]+:)?//', 'i');
  return r.test(url)
}

export default isExternal
